import { Injectable } from '@angular/core';
import { StorageValue } from '../../../models/utils';

@Injectable({
  providedIn: 'root'
})
export class StorageHelperService {
  /**
   *  Set a cookie.
   */
  setCookie(
    key: string,
    value: StorageValue = '',
    path = '/',
    domain: string = window.location.hostname,
    ttl = 0
  ): string {
    const cookieValue = JSON.stringify(value);
    const cookie = [
      key + '=' + escape(cookieValue),
      'path=' + path,
      'domain=' + domain
    ];
    const expiryTime = ttl === 0 ? ttl : (ttl / 1000) * 60 * 60;
    cookie.push('max-age=' + expiryTime);
    return (window.document.cookie = cookie.join('; ')) ?? '';
  }

  /**
   * Unset Cookie.
   */
  unsetCookie(key: string): boolean {
    if (this.getCookie(key)) {
      this.setCookie(key, '', '/', '.delta.com', 0);
      return true;
    }
    return false;
  }

  /**
   * Get the selected language from the Cookie name passed.
   */
  getSelectedLanguage(cookieName: string, cookieValue = false): string {
    const prefCookieValue = this.getCookie(cookieName) || 'en-us';

    if (cookieValue) {
      return prefCookieValue;
    } else {
      const prefCookieSplit = prefCookieValue.split('-');
      const languageSelected = prefCookieSplit[0] || 'en';
      return languageSelected.toLowerCase();
    }
  }

  /**
   * Get a cookie's value.
   */
  getCookie(cookieName: string): string {
    if (cookieName) {
      const name = cookieName.toLowerCase();
      const crumbles = window.document.cookie.split(';');
      const len = crumbles.length;

      for (let i = 0; i < len; i++) {
        const pair = crumbles[i].split('=');
        const key = decodeURIComponent(pair[0].trim().toLowerCase());
        const val = this.checkPairLength(pair);

        if (name === key) {
          return decodeURIComponent(val);
        }
      }
    }
    return '';
  }

  checkPairLength(pair: string[]): string {
    return pair.length > 1 ? pair[1] : '';
  }
}
